import Hls from 'hls.js';
import React, { RefObject, useEffect, useRef } from 'react';
import './videoPlayerHls.scss';
import { applyEmbbedStyleToPlayer } from '@/lib/util';

const loadVideo = (link: string, videoNode: RefObject<HTMLVideoElement>) => {
  if (!videoNode.current) return;
  if (!link) return;

  if (Hls.isSupported()) {
    const hlsPlayer = new Hls();
    hlsPlayer.loadSource(link);
    hlsPlayer.attachMedia(videoNode.current);
  } else if (videoNode.current.canPlayType('application/vnd.apple.mpegurl')) {
    videoNode.current.src = link;
  }
};

const VideoPlayerHls = ({
  videoLink,
  useHls,
  option,
}: {
  videoLink: string;
  useHls?: boolean;
  option?: any;
}) => {
  const videoNode = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (!useHls) return;
    loadVideo(videoLink, videoNode);
  }, [videoLink]);

  useEffect(() => {
    if (!option) return;

    const { mountType, style, styleId } = option;
    const videoMount = document.getElementById(styleId);

    if (mountType === 'embed' && videoMount) {
      applyEmbbedStyleToPlayer(option, videoMount, videoNode);
    }

    if (mountType === 'popup') {
      if (style && videoNode.current) {
        videoNode.current.style.cssText = style;
      }
    }
  }, [option, videoNode]);

  return (
    <div className="video-player-hls">
      <video
        className="video-player-hls"
        src={videoLink}
        ref={videoNode}
        controls
        muted={!!option}
        autoPlay={option ? option.autoplay : true}
      >
        <track kind="captions" />
      </video>
    </div>
  );
};

export default VideoPlayerHls;
